import { Box, Flex, Paper, ScrollArea, Space } from "@mantine/core";
import YourProperties from "./YourProperties";
import MeterTable from "./MeterTable";
import MeterOverview from "./MeterOverview";
import YourPages from "./YourPages";
import useDashboardHook from "../../hooks/useDashboardHook";
import { METER_SIDEBAR_SELECTOR, PAGE_TABS_ACCESSORS } from "../../constants";
import styles from "../../styles/elements.module.css";
import MeterDataView from "./MeterDataView";
import MeterDetailsView from "./MeterDetailsView";
import MeterCutOffsView from "./MeterCutOffsView";
import ShareMetersView from "./ShareMetersView";
import BillingView from "./BillingView";

export default function DashboardView() {
  const {
    selectedPageTab,
    useProperties,
    usePageTabs,
    useMeters,
    selectedPropertyId,
    selectedMeter,
    closeMeterOverviewSidebar,
    meterSidebarSelector,
    selectedMetersForSharing,
  } = useDashboardHook();

  const {
    meters,
    loading: loadingMeters,
    handleMeterSelect,
    onMenuClick,
    onAllReadingsClick,
    selectedMetersForSharing: metersForSharing,
    toggleMeterForSharing,
    onShareClick,
  } = useMeters(selectedPropertyId);

  const shouldShowSidebar =
    (selectedMeter && meterSidebarSelector) ||
    (meterSidebarSelector === METER_SIDEBAR_SELECTOR.meterShare &&
      selectedMetersForSharing.length > 0);

  return (
    <Flex
      mih={"100dvh"}
      h={"100%"}
      w={"100%"}
      wrap={{ base: "wrap", md: "nowrap" }}
    >
      <>
        <Box
          w={shouldShowSidebar ? "70%" : "100%"}
          p={"xl"}
          style={{
            overflowY: "auto",
          }}
          mah={"100dvh"}
          className={styles["custom-scrollbar"]}
          visibleFrom="md"
        >
          <ScrollArea>
            <YourProperties useProperties={useProperties} />
          </ScrollArea>
          <Space h="xl" />
          <YourPages
            selectedPageTab={selectedPageTab}
            usePageTabs={usePageTabs}
          />
          <Space h={60} />
          {selectedPageTab === PAGE_TABS_ACCESSORS.meter.value ? (
            meterSidebarSelector ===
              METER_SIDEBAR_SELECTOR.meterPayloadDetails && selectedMeter ? (
              <MeterCutOffsView meter={selectedMeter} />
            ) : (
              <MeterTable
                loadingMeters={loadingMeters}
                meters={meters}
                handleMeterSelect={handleMeterSelect}
                onMenuClick={onMenuClick}
                onAllReadingsClick={onAllReadingsClick}
                selectedMeter={selectedMeter}
                selectedMetersForSharing={metersForSharing}
                toggleMeterForSharing={toggleMeterForSharing}
                onShareClick={onShareClick}
              />
            )
          ) : null}
          {selectedPageTab === PAGE_TABS_ACCESSORS.billing.value && (
            <BillingView propertyId={selectedPropertyId || null} meters={meters} />
          )}
        </Box>
        <Box hiddenFrom="md" p={"sm"} w={"100%"}>
          <ScrollArea>
            <YourProperties useProperties={useProperties} />
          </ScrollArea>
          <Space h="xl" />
          <YourPages
            selectedPageTab={selectedPageTab}
            usePageTabs={usePageTabs}
          />
          <Space h={60} />
          <ScrollArea>
            {selectedPageTab === PAGE_TABS_ACCESSORS.meter.value ? (
              meterSidebarSelector ===
                METER_SIDEBAR_SELECTOR.meterPayloadDetails && selectedMeter ? (
                <MeterCutOffsView meter={selectedMeter} />
              ) : (
                <MeterTable
                  loadingMeters={loadingMeters}
                  meters={meters}
                  handleMeterSelect={handleMeterSelect}
                  onMenuClick={onMenuClick}
                  onAllReadingsClick={onAllReadingsClick}
                  selectedMeter={selectedMeter}
                  selectedMetersForSharing={metersForSharing}
                  toggleMeterForSharing={toggleMeterForSharing}
                  onShareClick={onShareClick}
                />
              )
            ) : null}
            {selectedPageTab === PAGE_TABS_ACCESSORS.billing.value && (
              <BillingView propertyId={selectedPropertyId || null} meters={meters} />
            )}
          </ScrollArea>
        </Box>

      </>
      {shouldShowSidebar ? (
        <Paper radius={"md"} p={"sm"} className={styles["aside-bar"]}>
          {meterSidebarSelector ===
            METER_SIDEBAR_SELECTOR.meterPayloadDetails &&
            selectedMeter && <MeterDataView meter={selectedMeter} />}
          {meterSidebarSelector === METER_SIDEBAR_SELECTOR.meterDetails &&
            selectedMeter && (
              <MeterDetailsView
                meter={selectedMeter}
                closeSidebar={closeMeterOverviewSidebar}
              />
            )}
          {meterSidebarSelector === METER_SIDEBAR_SELECTOR.meterOverview &&
            selectedMeter && (
              <MeterOverview
                meter={selectedMeter}
                close={closeMeterOverviewSidebar}
              />
            )}
          {meterSidebarSelector === METER_SIDEBAR_SELECTOR.meterShare && (
            <ShareMetersView
              meters={selectedMetersForSharing}
              close={closeMeterOverviewSidebar}
            />
          )}
        </Paper>
      ) : null}
    </Flex>
  );
}
